import { Box, CircularProgress } from '@mui/material';
import { MonochromeButton } from 'apps/wrapper/src/components/shared/buttons/buttons.styles';
import { useLocations } from 'apps/wrapper/src/hooks/use-locations';
import { SearchFilter } from 'apps/wrapper/src/hooks/use-search/types/search-filter';
import { useSearch } from 'apps/wrapper/src/hooks/use-search/use-search';
import { useViewMode } from 'apps/wrapper/src/hooks/use-view-mode';
import { FC } from 'react';
import { VerticalSeparator } from '../../search-bar.styles';
import { SearchResultsCounterWrapper, SearchResultsFilterWrapper } from './search-results-filter.styles';

export const SearchResultsFilter: FC = () => {
  const { locations } = useLocations();
  const { isLoading, data, queryFilter, setQueryFilter } = useSearch();
  const { viewMode } = useViewMode();
  const isPhone = viewMode === 'Phone';
  const isTablet = viewMode === 'Tablet';

  const setFilter = (value: Partial<SearchFilter>) => {
    setQueryFilter((x) => ({ ...x, ...value }));
  };

  return (
    <SearchResultsFilterWrapper>
      {locations && locations.length > 1 && (
        <>
          <MonochromeButton
            variant="outlined"
            color="info"
            isPhone={isPhone || isTablet}
            selected={queryFilter.area === 'Location'}
            onClick={() => setFilter({ area: 'Location' })}
            sx={{ marginRight: '10px' }}
          >
            Location
          </MonochromeButton>
          <MonochromeButton
            variant="outlined"
            color="info"
            isPhone={isPhone || isTablet}
            selected={queryFilter.area === 'Network'}
            onClick={() => setFilter({ area: 'Network' })}
            sx={{ marginRight: '10px' }}
          >
            Network
          </MonochromeButton>
          <MonochromeButton
            variant="outlined"
            color="info"
            isPhone={isPhone || isTablet}
            selected={queryFilter.area === 'All'}
            onClick={() => setFilter({ area: 'All' })}
          >
            All
          </MonochromeButton>
          <VerticalSeparator sx={{ height: '32px' }} />
        </>
      )}

      <MonochromeButton
        variant="outlined"
        color="info"
        isPhone={isPhone || isTablet}
        selected={queryFilter.activePatientsOnly}
        onClick={() => setFilter({ activePatientsOnly: !queryFilter.activePatientsOnly })}
      >
        Active Only
      </MonochromeButton>
      <SearchResultsCounterWrapper isPhone={isPhone || isTablet} isSingleLocation={locations && locations.length === 1}>
        {isLoading && <CircularProgress size={26} sx={{ padding: '0 20px' }} />}
        {!isLoading && data && data.length > 0 && (
          <Box>
            {data.length} {`${data.length === 1 ? 'Result' : 'Results'}`}
          </Box>
        )}
      </SearchResultsCounterWrapper>
    </SearchResultsFilterWrapper>
  );
};
